import { UPDATE_VALUES } from './types';

export const saveValuesToState = (data) => async dispatch => {
    try {
        dispatch({ type: UPDATE_VALUES, payload: data });
    } catch (errors) {
        // dispatch({ type: SET_ERRORS, payload: { error: "Unable to get current step" }});
    }
};